export default __webpack_public_path__ + "static/media/qatar_icon.9051ee69.png";